import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Tours from "@/pages/Tours";
import TourDetail from "@/pages/TourDetail";
import Consultations from "@/pages/Consultations";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Partner from "@/pages/Partner";
import PartnerPortal from "@/pages/PartnerPortal";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ProtectedRoute from "@/components/ProtectedRoute";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ScrollToTop from "@/components/ScrollToTop";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/tours" element={<Tours />} />
      <Route path="/tours/:slug" element={<TourDetail />} />
      <Route path="/about" element={<About />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/consultations" element={<Consultations />} />
      <Route path="/login" element={<Login />} />
      <Route path="/partner" element={<Partner />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/partner/portal" element={<ProtectedRoute roles={["partner", "admin"]}><PartnerPortal /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <FloatingWhatsApp />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}
